import api from '../utils/api';

export const getAllStudents = async (headers) => {
  try {
    const response = await api.get('/api/students', headers);
    if (response && response.data) {
      console.log('API response data for all students:', response.data);
      return response.data;
    } else {
      throw new Error('Response data is undefined');
    }
  } catch (error) {
    console.error('Error fetching all students:', error.response ? error.response.data : error.message);
    throw error;
  }
};


// Fetch a specific student by ID
export const getStudentById = async (id, headers) => {
  try {
    const response = await api.get(`/api/students/${id}`,  headers );
    console.log('API response data for one student:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error fetching student with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new student
export const createStudent = async (studentData, headers) => {
  try {
    const response = await api.post('/api/students', studentData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error creating student:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing student
export const updateStudent = async (id, studentData, headers) => {
  try {
    const response = await api.put(`/api/students/${id}`, studentData,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error updating student with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a student
export const deleteStudent = async (id, headers) => {
  try {
    const response = await api.delete(`/api/students/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error deleting student with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};


// Delete a student
export const getStudentGradesWithDetails = async (studentId, headers) => {
  try {
    const response = await api.get(`/api/students/student/${studentId}`,  headers );
    console.log("getStudentGradesWithDetails", response.data)
    return response.data;
  } catch (error) {
    console.error(`Error deleting student with ID ${studentId}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};